import { updateAccessStatus } from 'vendor/application/disptach';
import $ from 'jquery';

const BASE = process.env.REACT_APP_URL_BACK;

function join(base, path) {
  const b = String(base || '').replace(/\/+$/, '');
  const p = String(path || '').replace(/^\/+/, '');
  return `${b}/${p}`;
}

export class CustomLogin {
  constructor(body, url, props) {
    this.base_url = BASE;
    this.url = url;
    this.body = body;
    this.props = props;
  }

  async make_request_token() {
    const fullUrl = join(this.base_url, this.url);

    try {
      const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      return await $.ajax({
        url: fullUrl,
        type: 'POST',
        data: JSON.stringify(this.body),
        dataType: 'json',
        headers,
      });
    } catch (jqXHR) {
      const status = jqXHR?.status ?? 0;
      const rt = jqXHR?.responseText;

      let rj = null;
      try {
        rj = rt ? JSON.parse(rt) : null;
      } catch (e) {
        rj = null;
      }

      if (typeof rt === 'string' && /<html/i.test(rt)) {
        throw new Error(`Se recibió HTML en ${fullUrl}. La petición no llegó al backend (revisa la ruta this.url).`);
      }

      switch (status) {
        case 400:
          throw new Error((rj?.username && rj.username[0]) ?? rj?.detail ?? 'Bad Request');
        default: {
          let message = 'Unexpected error occurred';
          if (rj?.message) message = rj.message;
          else if (rj?.detail) message = rj.detail;
          
          throw new Error(message);
        }
      }
    }
  }

  async make_request_refresh() {
    const { access } = this.props.data;
    const fullUrl = join(this.base_url, this.url);

    let result;
    try {
      result = await $.ajax({
        url: fullUrl,
        type: 'POST',
        data: JSON.stringify(this.body),
        dataType: 'json',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      });
    } catch (jqXHR) {
      result = { response: jqXHR, status: jqXHR?.status ?? 0 };
    }

    if (!result || !result.access) {
      const updatedAccess = { ...access, isAccess: false, userId: access?.userId };
      this.props.dispatch(updateAccessStatus(updatedAccess));
      throw new Error('The session has expired, please log in again');
    }

    const updatedAccess = { ...access, access: result.access, isAccess: true };
    this.props.dispatch(updateAccessStatus(updatedAccess));
    return result;
  }
}